import { PaymentSource, Transaction } from '@/components/Invoice/types';
import { formatCurrency } from '@airwallex/awx-currency-formatter';

export const formatPaymentSource = (payment?: PaymentSource) => {
  if (payment?.type === 'card') {
    return payment?.cardBrandDisplayName || payment?.type;
  }
  return payment?.displayName || payment?.type;
};

export const formatTransaction = (transaction?: Transaction) => {
  if (transaction?.paymentMethodType === 'card') {
    return transaction?.cardBrandDisplayName || transaction?.paymentMethodType;
  }
  return transaction?.paymentMethodDisplayName || transaction?.paymentMethodType;
};

export const formatCardLast4 = (cardLast4?: string) => {
  return cardLast4 ? ` ${cardLast4}` : '';
};

export const formatMoney = (amount: number, currency: string) =>
  formatCurrency({ amount, currency, showSymbol: true, showCode: false });
